import { routeMiddleware } from '@/router/middlewares/types/routeMiddleware';
import { useUserDataStore } from '@/stores/UserData';

export const defaultGuard: routeMiddleware = ({
  to, next, abort,
}) => {
  const { disableGuard } = to?.meta || {};

  if (disableGuard || useUserDataStore().isAuthenticated) {
    return next();
  }

  return abort({ name: 'entrance', query: to.query });

};
